//////////////////////////////////////////////////////////////////////////////
//
//  Point Use Policy API
//
//  작성자: MediInStep Team
//  생성일: 2025-12-26
//
//  설명: 포인트 사용 정책 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 포인트 사용 정책 관련 API
 */
const PointUsePolicyAPI: ApiGroup = {
    pagedList: {
        title: "사용 정책 목록 조회",
        url: "/PointUsePolicy/PagedList",
        method: "POST",
        paramz: {},
    },
    list: {
        title: "전체 사용 정책 목록 조회",
        url: "/PointUsePolicy/List",
        method: "GET",
        paramz: {},
    },
    getById: {
        title: "사용 정책 상세 조회",
        url: "/PointUsePolicy/:id",
        method: "GET",
        paramz: {},
        pathParams: ["id"],
    },
    create: {
        title: "사용 정책 등록",
        url: "/PointUsePolicy",
        method: "POST",
        paramz: {},
    },
    update: {
        title: "사용 정책 수정",
        url: "/PointUsePolicy/:id",
        method: "PUT",
        paramz: {},
        pathParams: ["id"],
    },
    delete: {
        title: "사용 정책 삭제",
        url: "/PointUsePolicy/:id",
        method: "DELETE",
        paramz: {},
        pathParams: ["id"],
    },
}

export default PointUsePolicyAPI
